import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import PathToConfidence from "./sections/PathToConfidence";
import TheBridgeToYourProject from "./sections/TheBridgeToYourProject";
import WhoWeServe from "./sections/WhoWeServe";
import ApplicationRoadmap from "./sections/ApplicationRoadmap";
import OurNetworkOfLenders from "./sections/OurNetworkOfLenders";
import BillingClarified from "./sections/BillingClarified";
import ElevateYourBrand from "./sections/ElevateYourBrand";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <PathToConfidence />
      <TheBridgeToYourProject />
      <WhoWeServe />
      <ApplicationRoadmap />
      <OurNetworkOfLenders />
      <BillingClarified />
      <ElevateYourBrand />
      <Footer />
    </div>;
}